/** Checkbox labels — must stay in sync with Recent Activity dropdown copy */
export const RECENT_ACTIVITY_NO_LESSONS = 'No lessons marked done'

export const RECENT_ACTIVITY_LESSON_LAST_14_DAYS = 'Lesson done in last 14 days'

export const RECENT_ACTIVITY_OPTIONS = [
  RECENT_ACTIVITY_NO_LESSONS,
  RECENT_ACTIVITY_LESSON_LAST_14_DAYS,
]

/** Empty set = no activity filter (show all rows, subject to grade filter). */
export const createDefaultActivitySelection = () => new Set()

/**
 * @param {object} row - ReportTableV2 class row
 * @param {Set<string>} selectedLabels
 */
export const rowMatchesActivitySelection = (row, selectedLabels) => {
  const selection =
    selectedLabels instanceof Set
      ? selectedLabels
      : new Set(Array.isArray(selectedLabels) ? selectedLabels : [])

  if (selection.size === 0) return true

  const lessonsMarkedDone =
    row.lessonsCompletedCore ?? row.lessonsCompleted ?? 0
  const noLessonsMarkedDone = lessonsMarkedDone === 0
  const lessonDoneInLast14Days = row.hasCompletedLessonLastPeriod === true

  let match = false
  if (selection.has(RECENT_ACTIVITY_NO_LESSONS)) {
    match = match || noLessonsMarkedDone
  }
  if (selection.has(RECENT_ACTIVITY_LESSON_LAST_14_DAYS)) {
    match = match || lessonDoneInLast14Days
  }
  return match
}
